import { render, staticRenderFns } from "./echarts.vue?vue&type=template&id=5bae5a90&scoped=true&"
import script from "./echarts.vue?vue&type=script&lang=js&"
export * from "./echarts.vue?vue&type=script&lang=js&"
import style0 from "./echarts.vue?vue&type=style&index=0&id=5bae5a90&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5bae5a90",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\project\\uniFrame\\uni-frame\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('5bae5a90')) {
      api.createRecord('5bae5a90', component.options)
    } else {
      api.reload('5bae5a90', component.options)
    }
    module.hot.accept("./echarts.vue?vue&type=template&id=5bae5a90&scoped=true&", function () {
      api.rerender('5bae5a90', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/mpvue-echarts/src/echarts.vue"
export default component.exports